import { Area } from "@ant-design/charts";
import type { CardProps } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import { DashboardCardContainer } from "src/app/features/Dashboard/utils/dashboardStyles";
import type { DailyActivityDto } from "../types/Dashboard";

interface WeeklyCampaignActivityCardProps extends CardProps {
    data: DailyActivityDto[];
}

/**
 * WeeklyCampaignActivityCard - Area chart showing terminals in campaigns per day
 */
export const WeeklyCampaignActivityCard: FC<WeeklyCampaignActivityCardProps> = ({ data, ...cardProps }) => {
    const chartData = data;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config: any = {
        data: chartData,
        xField: "day",
        yField: "value",
        smooth: true,
        style: {
            fill: "l(270) 0:#1890ff 0.5:#7ec2f3 1:#f0f5ff",
            fillOpacity: 0.6,
        },
    };

    return (
        <DashboardCardContainer title={i18n.t("dashboard.weeklyCampaignActivity")} {...cardProps}>
            <Area {...config} />
        </DashboardCardContainer>
    );
};
